/**
 * main.tsx
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { createRoot } from 'react-dom/client';
import { Widget }     from '~/components/widget';

document.addEventListener('DOMContentLoaded', () => {
  /**
   * Try to get the #root element. */
  const rootElement = document.getElementById('rating-root');
  if (!rootElement)
  {
    /**
     * @NOTE (Maurice):
     * Couldn't find the required root element. */
    throw new Error(`No #root element found`);
  }

  const configElement = document.getElementById('rating-conf');
  if(!configElement?.textContent)
    {
    throw new Error('No configuration found for the widget');
  }

  /**
   * Render the React component. */
  const root   = createRoot(rootElement);
  const config = JSON.parse(configElement.textContent);

  root.render(<Widget config={config} />);
});
